import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Application, Feature } from '@frontend/functionality/types';

import { TransactionReturnReasonName } from './transaction-return-reason';
import { TransactionStateName } from './transaction-state';

export interface Transaction {
    delete_timestamp: string | null;
    sender_ids: string[] | null;
    receiver_ids: string[] | null;
    dropped_off_by_id: string | null;
    picked_up_by_id: string | null;
    initiated_by_id: string | null;
    tracking_number: string | null;
    iot_id: string | null;
    user_id: string | null;
    state: TransactionStateName;
    application: Application | null;
    feature: Feature | null;
    spot_id: string | null;
    module_id: string | null;
    slot_id: string | null;
    deceased_id: string | null;
    courier: TransactionCourier | null;
    supplier: string | null;
    purchase_order: string | null;
    shipping_notes: string | null;
    shipping_address: { [key: string]: any } | null;
    comments: string | null;
    return_reason: TransactionReturnReasonName | null;
    schedule_start_timestamp: string | null;
    schedule_stop_timestamp: string | null;
    update_timestamp: string;
    workflow_id: string;
    type: TransactionType;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export type TransactionListResponse = PaginatedResponse<Transaction>;

export interface CreateTransaction {
    tracking_number?: string | null;
    iot_id?: string | null;
    user_id?: string | null;
    state?: TransactionStateName;
    application?: Application | null;
    feature?: Feature | null;
    spot_id?: string | null;
    module_id?: string | null;
    slot_id?: string | null;
    deceased_id?: string | null;
    courier?: TransactionCourier | null;
    supplier?: string | null;
    purchase_order?: string | null;
    shipping_notes?: string | null;
    comments?: string | null;
    return_reason?: TransactionReturnReasonName | null;
    workflow_id?: string;
    type?: TransactionType;
    shipping_address?: { [key: string]: any } | null;
}

export interface UpdateTransaction {
    null_fields?: string[] | null;
    tracking_number?: string | null;
    iot_id?: string | null;
    user_id?: string | null;
    workflow_id?: string | null;
    state?: TransactionStateName | null;
    application?: Application | null;
    feature?: Feature | null;
    spot_id?: string | null;
    slot_id?: string | null;
    deceased_id?: string | null;
    courier?: TransactionCourier | null;
    supplier?: string | null;
    purchase_order?: string | null;
    shipping_notes?: string | null;
    comments?: string | null;
    return_reason?: TransactionReturnReasonName | null;
    schedule_start_timestamp?: string | null;
    schedule_stop_timestamp?: string | null;
    shipping_address?: { [key: string]: any } | null;
}

export enum SearchTransactionQueryParams {
    PARTIAL_TEXT = 'partial_text'
}

enum QueryParams {
    STATE = 'state',
    USER_ID = 'user_id',
    SPOT_ID = 'spot_id',
    SLOT_ID = 'slot_id',
    PACKAGE_SPOT_ID = 'package_spot_id',
    ACCOUNT_ID = 'account_id',
    TYPE = 'type',
    WORKFLOW_ID = 'workflow_id',
    TRACKING_NUMBER = 'tracking_number',
    APPLICATION = 'application',
    FEATURE = 'feature',
    MODULE_ID = 'module_id',
    SENDER_ID = 'sender_id',
    RECEIVER_ID = 'receiver_id',
    ACTIVE = 'active',
    CURRENT_SPOT_ID = 'current_spot_id',
    // Used by ext PuDo transactions endpoint to reduce payload when the UI doesn't render these.
    WITHOUT_COLLIS = 'without_collis',
    WITHOUT_PACKAGES = 'without_packages',
    WITHOUT_PIN_CODES = 'without_pin_codes',
    REQUIRE_SLOT = 'require_slot'
}
export type TransactionQueryParams = DefaultQueryParams | QueryParams;

export enum TransactionCourier {
    BPOST = 'bpost'
}

export enum TransactionType {
    AUDIT = 'audit',
    LENDING = 'lending',
    OPEN_DROP_OFF = 'open_drop_off',
    PASS_THROUGH = 'pass_through',
    PUDO = 'pudo',
    VENDING = 'vending',
    WAREHOUSE = 'warehouse'
}

export interface UpdateTransactionState {
    state?: TransactionStateName;
}
